import { useOidc, useOidcUser } from "@axa-fr/react-oidc";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router";
import { Icon } from "@/components/icon";
import { Persona } from "@/components/persona";
import { Avatar, AvatarFallback, AvatarImage } from "@/ui/avatar";
import { Button } from "@/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/ui/dropdown-menu";

function getFullnameOrDefault(name?: string, surname?: string, defaultName?: string): string {
  if (surname && name) {
    return `${name} ${surname}`;
  }
  if (name) {
    return name;
  }
  if (surname) {
    return surname;
  }

  return defaultName ?? "Unknown";
}

/**
 * Account Dropdown
 */
export default function AccountDropdown() {
  const { oidcUser } = useOidcUser();
  const { logout } = useOidc();
  const { t } = useTranslation();

  const { preferred_username = "", family_name, given_name } = oidcUser || {};

  const handleLogout = async () => {
    await logout();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="rounded-full">
          <Avatar className="size-6">
            <AvatarImage src="" />
            <AvatarFallback>
              <Icon icon="lucide:user-round" />
            </AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56">
        <div className="p-2">
          <Persona size="lg" nickname={getFullnameOrDefault(given_name, family_name)} username={preferred_username} />
        </div>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <NavLink
            to="https://aptbu6pox3.feishu.cn/wiki/S8f8wfK1XijWO9kp5OacGFj0neh?from=from_copylink"
            target="_blank"
          >
            {t("sys.docs")}
          </NavLink>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem className="font-bold text-warning" onClick={handleLogout}>
          {t("sys.login.logout")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
